import { Component, OnInit } from '@angular/core'
import { ActiveFacetsComponent, FacetService } from '@spartacus/storefront'

@Component({
    selector: 'app-custom-active-facets',
    templateUrl: './custom-active-facets.component.html',
    styleUrls: ['./custom-active-facets.component.scss'],
    standalone: false
})
export class CustomActiveFacetsComponent extends ActiveFacetsComponent implements OnInit {
  constructor(protected facetService: FacetService) {
    super(facetService)
  }

  ngOnInit(): void {}
}
